import { useMemo } from "react";

import { useTheme } from "@/contexts/theme-provider";

export function getCssVar(name: string): string {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  // CSS vars are stored as RGB triplets like "27 33 27"
  const parts = value.split(/\s+/).map(Number);
  if (parts.length === 3 && parts.every((n) => !isNaN(n))) {
    return "#" + parts.map((n) => n.toString(16).padStart(2, "0")).join("");
  }
  return value;
}

function buildTheme() {
  return {
    "style-input-background-color": getCssVar("--background"),
    "style-input-text-color": getCssVar("--foreground"),
    "style-border-color": getCssVar("--input"),
    "style-button-color": getCssVar("--primary"),
    "style-secondary-button-color": getCssVar("--accent"),
    "style-secondary-button-font-color": getCssVar("--accent-foreground"),
    "style-icon-color": getCssVar("--foreground-muted"),
    "style-placeholder-text-color": getCssVar("--foreground-muted"),
    "style-list-alternate-row-color": getCssVar("--row-hover"),
  };
}

/**
 * Returns style-* attribute props for the <rainforest-payment> web component
 * that adapt to the current light/dark theme via CSS variables.
 */
export function useRainforestTheme() {
  const { resolvedTheme } = useTheme();

  return useMemo(() => buildTheme(), [resolvedTheme]);
}
